import { useQuery } from 'react-query';
import { ConfigResponse, LegalDocsConfigurations } from '../types';
import { getSellerComplianceConfigData } from '../api';
import { useOrganizationPackagesData } from './useOrganizationPackagesData';

export const SELLER_CONFIG_QUERY_KEY = 'SELLER_CONFIG_QUERY';

export const useSellerConfigData = (sellerId: number, autofetch = true) => {
    const initialData: ConfigResponse | undefined = undefined;
    const { legalDocumentsPackageData, isPackagesDataLoading } = useOrganizationPackagesData();

    const userSellerDataQuery = useQuery({
        queryKey: [SELLER_CONFIG_QUERY_KEY, sellerId?.toString()],
        queryFn: async (): Promise<ConfigResponse> => getSellerComplianceConfigData({ sellerId }),
        enabled: autofetch && !!sellerId,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        staleTime: Infinity,
        initialData,
    });

    const sellerConfigs = userSellerDataQuery?.data;

    return {
        isLoading: userSellerDataQuery?.isLoading || isPackagesDataLoading || userSellerDataQuery?.isFetching,
        sellerConfigs,
        legalDocsConfigurations: {
            ...(sellerConfigs?.legalDocsData || {}),
            legalDocumentsPackageData,
        } as LegalDocsConfigurations,
        legalDocumentsPackageData,
        refetchSellerConfigs: () => userSellerDataQuery.refetch({ stale: true }),
        isUsSeller: sellerConfigs?.backgroundCheckData?.isUs,
    };
};
